import { LoaderFunction } from 'react-router-dom';

import { fetchGraphQL } from 'src/services/contentful/client';
import { isPreviewMode } from 'src/utils/isPreviewMode';
import { GetArticleCollectionQuery, GetArticleCollectionQueryVariables } from 'src/graphql/generated/graphql';
import { Article, GET_ARTICLE } from 'src/graphql/queries/GetArticle';

export const loader: LoaderFunction = async ({ params }): Promise<ArticleLoaderProps> => {
  const baseSlug = params.slug ?? '';
  const wildcardPath = params['*'] ?? '';

  // Combine the base slug with the wildcard path to get the full slug for nested routes
  const fullSlug = wildcardPath ? `${baseSlug}/${wildcardPath}` : baseSlug;

  const preview = isPreviewMode();

  const articleData = await getArticleData(fullSlug, preview);

  if (!articleData) {
    throw new Error('Article was not found');
  }

  return { articleData };
};

const getArticleData = async (slug: string, preview: boolean): Promise<Article> => {
  const response = await fetchGraphQL<GetArticleCollectionQuery, GetArticleCollectionQueryVariables>(GET_ARTICLE, {
    preview,
    slug,
  });

  return response?.articleCollection?.items?.[0];
};

export interface ArticleLoaderProps {
  articleData: Article;
}
